import { useSelector } from 'react-redux';

import { getFilterLocation } from 'shared/selectors/filters/getFilterLocation';
import { LOCATION } from 'shared/settings/regions';

const SERIA_PLUS_LOCATIONS: number[] = [LOCATION.MOSCOW_AND_AREA.ID, LOCATION.SPB_AND_AREA.ID, LOCATION.KAZAN.ID];

export function getIsSeriaPlusEnabledForLocation(location: number): boolean {
  return SERIA_PLUS_LOCATIONS.includes(location);
}

export function useIsSeriaPlusEnabled(): boolean {
  const location = useSelector(getFilterLocation);

  return getIsSeriaPlusEnabledForLocation(location);
}
